type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

export const INVOICE_REPORTS_LOGS_HEADER: Header[] = [
  {
    key: "status",
    label: "Status",
    style: { width: "15%" },
  },
  {
    key: "oldAmount",
    label: "Old Amount",
    style: { width: "15%" },
  },
  {
    key: "newAmount",
    label: "New Amount",
    style: { width: "15%" },
  },
  {
    key: "updatedBy",
    label: "Updated By",
    style: { width: "20%" },
  },
  {
    key: "updatedOn",
    label: "Updated On",
    style: { width: "20%" },
  },
];
